import { cn } from "@/lib/utils";

type EditorialBrandImageProps = {
  alt?: string;
  className?: string;
};

export function EditorialBrandImage({
  alt = "Vaxy",
  className,
}: EditorialBrandImageProps) {
  return (
    <img
      src="/images/editorial/vaxy-brand-card.webp"
      alt={alt}
      width={1536}
      height={1024}
      loading="lazy"
      className={cn("block h-full w-full", className)}
    />
  );
}
